import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";

const ProposalInviteAccept = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");
  const contactId = searchParams.get("contact_id");

  useEffect(() => {
    // Redirect to the correct invitation page
    if (token && contactId) {
      navigate(`/invite-contact?token=${token}&contact_id=${contactId}`, { replace: true });
    } else if (token) {
      navigate(`/invite-contact?token=${token}`, { replace: true });
    } else {
      navigate('/auth', { replace: true });
    }
  }, [token, contactId, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="flex items-center justify-center gap-2 text-muted-foreground">
            <AlertCircle className="h-5 w-5" />
            Redirecting...
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-muted-foreground">
            Redirecting you to the correct invitation page...
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default ProposalInviteAccept;